import {
  Box,
  Card,
  Stack,
  Dialog,
  Avatar,
  CardHeader,
  Typography,
  DialogTitle,
  DialogContent,
  CardActionArea,
  CircularProgress,
} from '@mui/material';

import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';

import graph from './graph';
import AddressCreationOrUpdate from './AddressCreationOrUpdate';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import { isEmptyObject } from 'helpers/formatObject';

const ProductAvatar = ({ customer }) => {
  const { id, firstname, lastname, cellphone } = customer;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Card>
      <CardActionArea onClick={handleOpen}>
        <CardHeader
          sx={{ p: 1 }}
          avatar={
            <Avatar sx={{ bgcolor: 'warning.lighter', color: 'warning.dark', width: 40, height: 40 }}>
              <AccountCircleRoundedIcon fontSize="small" color="inherit" />
            </Avatar>
          }
          title={
            <Typography textAlign="center" color="warning.dark" fontWeight="bold" fontSize={12} variant="subtitle1">
              {firstname || ''} {lastname || '-'}
            </Typography>
          }
          subheader={
            <Typography fontWeight="bold" fontSize={16} variant="subtitle1">
              {cellphone}
            </Typography>
          }
        />
      </CardActionArea>
      <Dialog
        dir="rtl"
        fullWidth
        open={open}
        maxWidth="md"
        PaperComponent={Box}
        onClose={handleClose}
        PaperProps={{
          sx: {
            minHeight: '30%',
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{ p: 1 }} component="div">
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="subtitle1" color="#fff" fontSize={16}>
              آدرس ها
            </Typography>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <UserAddress ids={id} />
        </DialogContent>
      </Dialog>
    </Card>
  );
};

const UserAddress = ({ ids }) => {
  const { userToken } = useSelector((state) => state.auth);

  const { loading, data, refetch } = useQuery(graph.users.query, {
    variables: { ids },
    context: {
      serviceName: graph.users.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const user = !isEmptyObject(data) && data[graph.users.name]?.data[0];

  if (loading) {
    return (
      <Stack justifyContent="center" alignItems="center" rowGap={2} height={300}>
        <CircularProgress color="primary" />
      </Stack>
    );
  }
  if (user) {
    return <Addresses data={user.addresses} refetch={refetch} />;
  }
};

const Addresses = ({ data, refetch }) => {
  if (data.length > 0) {
    return data.map((item, i) => <AddressCard key={i} address={item} refetch={refetch} />);
  }
  return (
    <Stack justifyContent="center" alignItems="center" rowGap={2} height={300}>
      <Typography variant="subtitle1" color="error">
        آدرسی برای این کاربر ثبت نشده است
      </Typography>
      <AddressCreationOrUpdate refetch={refetch} />
    </Stack>
  );
};

const AddressCard = ({ address, refetch }) => {
  const { title, main_street } = address;
  return (
    <Card>
      <CardHeader
        title={title}
        subheader={main_street}
        action={
          <Stack direction="row" justifyContent="flex-end" columnGap={0.5}>
            <AddressCreationOrUpdate address={address} refetch={refetch} />
          </Stack>
        }
      />
    </Card>
  );
};

export default ProductAvatar;
